import { numberHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useNetSuiteInvoiceFieldSettings } from 'shared/hooks';

import { NetSuiteInvoiceListItemExpanded } from '../../data/types';
import { isCustomPriceLevel } from '../../helpers';
import { GroupEditItemsField } from '../../hooks';
import { isFieldReadOnly, isFieldVisible } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const getGroupEditItemsAvailableFields = (fieldSettings: ReturnType<typeof useNetSuiteInvoiceFieldSettings>) => {
    const availableFields = [GroupEditItemsField.Item];

    if (isFieldVisible(fieldSettings.itemsTaxCode) && !isFieldReadOnly(fieldSettings.itemsTaxCode)) {
        availableFields.push(GroupEditItemsField.TaxCode);
    }

    if (isFieldVisible(fieldSettings.itemsClass) && !isFieldReadOnly(fieldSettings.itemsClass)) {
        availableFields.push(GroupEditItemsField.Class);
    }

    if (isFieldVisible(fieldSettings.itemsDepartment) && !isFieldReadOnly(fieldSettings.itemsDepartment)) {
        availableFields.push(GroupEditItemsField.Department);
    }

    if (isFieldVisible(fieldSettings.itemsLocation) && !isFieldReadOnly(fieldSettings.itemsLocation)) {
        availableFields.push(GroupEditItemsField.Location);
    }

    return availableFields;
};

export const isUnitPriceFieldDisabledByPriceLevel = (
    li: NetSuiteInvoiceListItemExpanded,
    fieldState?: domain.DocumentFieldState
) => !isCustomPriceLevel(li.priceLevel) || Boolean(fieldState && isFieldReadOnly(fieldState));

export const isAmountFieldDisabledByPriceLevel = (
    li: NetSuiteInvoiceListItemExpanded,
    fieldState?: domain.DocumentFieldState
) =>
    !li.priceLevel ||
    (!isCustomPriceLevel(li.priceLevel) && numberHelpers.isNumber(li.defaultRate)) ||
    Boolean(fieldState && isFieldReadOnly(fieldState));
